// removed by extract-text-webpack-plugin
module.exports = {"Sticker":"_1tOyElaCOYvqm1bZQpcVW8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sticker/Sticker.css
// module id = 302
// module chunks = 8